<template>
  <div class="modal-wrapper" v-if="showModal">
    <div class="modal-bg" @click="closeModal"></div>
    <div class="modal-card card">
      <div class="modal-header p-4">
        <h3 class="h5">Submit enquiry</h3>
        <span class="icon-x h5" @click="closeModal"></span>
      </div>
      <div class="modal-content p-4">
        <loggedInEnquiry />
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line
import loggedInEnquiry from "@/components/layout/loggedInEnquiry";
export default {
    data () {
        return {
            showModal: true,
        };
    },
    components: {
        loggedInEnquiry,
    },
    methods: {
        closeModal () {
            this.$store.commit('toggleEnquiriesModal', false);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.modal-wrapper {
  bottom: 0px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 2;
  .modal-bg {
    position: absolute;
    top: 0;
    height: 100vh;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 3;
  }
  .loader {
    min-height: 100px;
    background: var(--primaryColour);
  }
  .modal-card {
    @include responsive("sm") {
      width: 90vw;
      min-width: unset;
    }
    min-width: 500px;
     max-width: 700px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    // height: 400px;

    z-index: 4;
    .modal-header {
      border: none;
      display: flex;
      justify-content: space-between;
      .icon-x {
        cursor: pointer;
      }
    }
    .modal-content {
      border: none;
      background: var(--greyColour);
      padding-bottom: 4rem !important;
    }
    .modal-footer {
      border: none;
    }
  }
}
</style>
